module.exports = __webpack_public_path__ + "static/media/rotor_sem_fundo.d686318b.png";